export default __webpack_public_path__ + "static/media/cookie1.fd615e16.svg";